import React from "react";

const HarmonyCodeInfo = () => {
    return (
        <div className={'alert-banner success-solid'}>
            <div className={'alert-banner-content'}>
                <div className={'alert-banner-title'}>Harmony / Commodity Codes</div>
                <p>From the 01/01/2021, all forwarding batches destined for outside of the United Kingdom require a Harmony Code for each item shipped. These codes classify the items, so that the recipient country understands what is being shipped.</p>

                <p>Some example codes are:</p>
                <ul>
                    <li>Books:
                        4901100000</li>
                    <li>Mobile phone:
                        8517110000</li>
                    <li>T-shirts:
                        6109100010</li>
                </ul>

                <p>For more general information, please visit our blog here. The Gov.UK Commodity search tool is here.</p>

            </div>
        </div>
    )
}

export { HarmonyCodeInfo }
